import ArrowLeft16 from '@carbon/icons-react/es/arrow--left/16';
import TrashCan16 from '@carbon/icons-react/es/trash-can/16';
import { Space } from 'antd';
import { ColumnType } from 'antd/lib/table';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { IntegrationField } from 'api/integrations';
import { Button } from 'components/atoms/button';
import { Switch } from 'components/atoms/switch/switch';
import { generateDynamicTableCells } from '../render-fields';

const RequiredMark = styled.span`
  color: var(--red-60);
`;

export const getFieldLabel = (name: string, isRequired?: boolean) => {
  return (
    <p>
      {isRequired ? <RequiredMark>*</RequiredMark> : null}
      {name}
    </p>
  );
};

const isDisabled = (jiraField: IntegrationField, disabled = false) => {
  if (jiraField.required) {
    return Boolean(!jiraField.metaData?.default);
  }

  return disabled;
};

export const getDynamicTableColumns = ({
  fieldsList,
  loading,
  disabled,
  onVisibilityChange,
  onFieldValueChange,
  onDelete,
}: {
  fieldsList: IntegrationField[];
  loading?: boolean;
  disabled?: boolean;
  onVisibilityChange: (fieldId: string, value: boolean) => void;
  onFieldValueChange: (valObject: any) => void;
  onDelete: (fieldId: string) => void;
}): ColumnType<IntegrationField>[] => [
  {
    title: <FormattedMessage id="settings.integrations.jira.table.fields" />,
    dataIndex: 'fieldName',
    width: 400,
    render: (fieldName, row) => {
      return getFieldLabel(fieldName, row.required);
    },
  },
  {
    key: 'arrow',
    render: () => <ArrowLeft16 />,
    width: 16,
  },
  {
    title: <FormattedMessage id="settings.integrations.jira.table.set_value" />,
    dataIndex: 'metaData',
    width: 340,
    render: (metaData, row) => {
      return generateDynamicTableCells({
        field: row,
        metaData,
        options: (fieldsList || [])?.find(
          (field) => field.integrationFieldId === row.integrationFieldId,
        )?.metaData?.options,
        onFieldValueChange,
        loading,
        disabled,
      });
    },
  },
  {
    title: (
      <FormattedMessage id="settings.integrations.jira.table.show_field" />
    ),
    dataIndex: 'isEnabled',
    render: (enabled, row) => (
      <Space size={16}>
        <Switch
          size="small"
          checked={enabled}
          disabled={isDisabled(row, disabled)}
          onChange={(visibility) =>
            onVisibilityChange(row.integrationFieldId, visibility)
          }
          loading={loading}
        />
      </Space>
    ),
  },
  {
    key: 'delete',
    render: (_, row) =>
      !row.required && (
        <Button
          type="text"
          icon={<TrashCan16 />}
          size="small"
          loading={loading}
          disabled={disabled}
          onClick={() => onDelete(row.integrationFieldId)}
        />
      ),
  },
];
